import { Saga } from './workers';

export default Saga;



// WEBPACK FOOTER //
// ./src/redux/questions/get-all/sagas.js